import { render, staticRenderFns } from "./Lecture.vue?vue&type=template&id=a4ee0940&"
import script from "./Lecture.vue?vue&type=script&lang=js&"
export * from "./Lecture.vue?vue&type=script&lang=js&"
import style0 from "./Lecture.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports